<template>
    <a :href="url" @click.prevent="print_page" :class="customclass">{{ label }}</a>
</template>

<script>
    import printJS from 'print-js'

    export default {
        props: {
            'label': {
                type: String,
                default: 'Print'
            },
            'url': {
                type: String
            },
            'customclass': {
                type: String,
                default: 'btn btn-border'
            }
        },
        methods : {
            print_page : function(){
                printJS({printable: this.url, type:'pdf', showModal:true});
            }
        }
    };
</script>